export const stackWalker = (stack) => {
  return stack.filter((element, index) => {
    if (element.namesub && !element.reqAuth) {
      stack[index].namesub = stackWalker(element.namesub);
    }
    return !element.reqAuth && element;
  });
};
